import { Button } from '@src/design-system/button';
import { Trash } from 'iconsax-react';
import { useTableViewHelpers } from '@design-system/molecules/ticlick-table/hooks/use-table-view-helpers';

export function DynamicCustomFieldFilterDeleteBtn({
  position,
}: {
  position: number;
}) {
  const { deleteCustomFieldFilter } = useTableViewHelpers();

  const onClick = () => {
    deleteCustomFieldFilter(position);
  };

  return (
    <Button
      variant='dangerPale'
      size='iconSm'
      onClick={onClick}
    >
      <Trash />
    </Button>
  );
}
